import { render, staticRenderFns } from "./OcrProcessUtil.vue?vue&type=template&id=6c2dd425"
import script from "./OcrProcessUtil.vue?vue&type=script&lang=js"
export * from "./OcrProcessUtil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports